export const API_KEY = '453dabb4-7645-4626-a1bb-477dff3aa557';

export const MONTH_NAMES_CA = ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Setembre', 'Octubre', 'Novembre', 'Desembre'];

export const CLIENT_FIELDS = [
    { key: 'businessName', label: 'Nom comercial', required: false, wide: true },
    { key: 'legalName', label: 'Raó social', required: true, wide: true },
    { key: 'nif', label: 'NIF', required: true, wide: false },
    { key: 'addressLine1', label: 'Adreça', required: true, wide: true },
    { key: 'postalCode', label: 'Codi postal', required: true, wide: false },
    { key: 'city', label: 'Ciutat', required: true, wide: false },
    { key: 'province', label: 'Província', required: false, wide: false },
    { key: 'email', label: 'Correu', required: false, wide: false },
    { key: 'companyPhone', label: 'Telèfon', required: false, wide: false },
    { key: 'iban', label: 'IBAN', required: false, wide: false },
];

export const CADENCE_LABELS = {
    monthly: 'Mensual',
    annual: 'Anual',
};

const MONTHLY_DEFAULT_COLLES = new Set([
    'matossers',
    'nova',
]);

export function getDefaultAletaBillingCadenceForColla(colla) {
    const normalizedColla = String(colla || '').trim().toLowerCase();
    return MONTHLY_DEFAULT_COLLES.has(normalizedColla) ? 'monthly' : 'annual';
}

export function createClientForm(baseProfile = {}) {
    return CLIENT_FIELDS.reduce((accumulator, field) => {
        accumulator[field.key] = baseProfile[field.key] || '';
        return accumulator;
    }, {});
}
